import { createAsyncActionTypes } from '../utils';

export const CHARGE_STRIPE_CUSTOMER = createAsyncActionTypes(
  'CHARGE_STRIPE_CUSTOMER'
);
